<template>
  <article class="app-view" :class="{
    'app-view--empty': empty,
  }">
    <main class="app-view__content">
      <slot />
    </main>
  </article>
</template>

<script>
export default {
  name: 'AppView',
  props: {
    empty: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style lang="scss">
.app-view {
  min-height: 900px;
  padding-bottom: 30px;

  background-image: url('~@/assets/artwork-left.png'), url('~@/assets/artwork-right.png');
  background-position: left top, right top;
  background-size: 300px auto, 300px auto;
  background-repeat: no-repeat, no-repeat;

  @media screen and (max-width: 1800px) {
    background-image: none;
  }

  &__content {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
  }

  &--empty {
    background-image: none;
  }

  &--empty &__content {
    max-width: 100%;
  }
}
</style>
